<template>
<section class="bg-grey-lighter">
  <div class="flex flex-col md:flex-row py-16 px-4 md:px-a container">
    <div class="w-full md:w-1/2 text-center">
      <img src="/assets/images/apis.png"/>
    </div>
    <div class="w-full md:w-1/2">
      <h2 class="text-4xl text-grey-darkest"><strong class="text-black">Strive</strong> for the best</h2>
      <div class="line line-left mt-4 mb-6"></div>
      <p class="leading-normal">
       A simple query to a WHOIS server is all well and good however doing something meaningful and programmatic with the data returned is a whole other story. This is where we step in, here at JsonWhoisAPI we put our experience in turning the data provided with no standards what so ever into a consistent machine usable Json format. We let you get on with building your app without having to think about the mess that is WHOIS.
       </p>
       <div class="flex flex-col my-4">
        <div class="bg-white flex items-center cursor-pointer" @click="openSection('intelicache')">
          <div class="bg-blue p-2">
            <svg class="fill-current h-6 w-6 text-white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Intelicache</title><path d="M1 4h2v2H1V4zm4 0h14v2H5V4zM1 9h2v2H1V9zm4 0h14v2H5V9zm-4 5h2v2H1v-2zm4 0h14v2H5v-2z"/></svg>
          </div>
          <div class="mx-4">Intelicache</div>
        </div>
        <div v-if="activeSection === 'intelicache'" class="bg-white mt-1 p-2 leading-normal">
          <p>The inconsistencies that exists from WHOIS server to WHOIS server mean that some servers require more advanced caching than others. Using our proprietary caching formula, Intelicache, we endeavour to bring you the fastest most up to date results possible, providing a stable platform to build your app upon.</p>
          <p>Intelicache leverages the collective WHOIS requests sent to our servers alongside our advanced crawling and auto updating service to provide a speedy and consistent experience. </p>
        </div>
       </div>


       <div class="flex flex-col my-4">
        <div class="bg-white flex items-center cursor-pointer" @click="openSection('api')">
          <div class="bg-blue p-2">
            <svg class="fill-current h-6 w-6 text-white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>REST API</title><path d="M.7 9.3l4.8-4.8 1.4 1.42L2.84 10l4.07 4.07-1.41 1.42L0 10l.7-.7zm18.6 1.4l.7-.7-5.49-5.49-1.4 1.42L17.16 10l-4.07 4.07 1.41 1.42 4.78-4.78z"/></svg>
          </div>
          <div class="mx-4">REST API</div>
        </div>
        <div v-if="activeSection === 'api'" class="bg-white mt-1 p-2 leading-normal">
          <p>Our core service is providing a single reliable interface to the sketchy world of WHOIS data. We eat, sleep, and breath REST APIs - they are simple and powerful thus JsonWhoisAPI was built with such an API as the center piece. The API <a href="docs">documentation</a> is clear and to the point and provides useful code samples, we have built the kind of API we would love to use.</p>
          <p>We convert unorignaised WHOIS data into a structured Json object.</p>
        </div>
       </div>



       <div class="flex flex-col my-4">
         <div class="bg-white flex items-center cursor-pointer" @click="openSection('service')">
           <div class="bg-blue p-2">
             <svg class="fill-current h-6 w-6 text-white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Your service</title><path d="M19.95 11A10 10 0 1 1 9 .05V11h10.95zm-.08-2.6H11.6V.13a10 10 0 0 1 8.27 8.27z"/></svg>
           </div>
           <div class="mx-4">Your service</div>
         </div>
         <div v-if="activeSection === 'service'"class="bg-white mt-1 p-2 leading-normal">
           <p>A service can have all the features you are looking for with a well-defined interface for usage however, if there is call throttling or a ludicrous pricing structure in place it can all mean nothing. We operate on a simple tiered pay as you go pricing structure giving you the freedom to pay only for what you use - perfect for any size business. Calls to our parsed WHOIS data service are not throttled at all meaning you don’t have to worry about this service being a bottleneck to yours!</p>
         </div>
       </div>
     </div>
    </div>
  </div>
</section>
</template>
<script>
export default {
  data () {
    return {
      activeSection: null
    }
  },
  methods: {
    openSection (section) {
      if (this.activeSection === section) {
        this.activeSection = null
      } else {
        this.activeSection = section
      }
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// app/javascript/components/home/service-info.vue?79fe339e